import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useMediaQuery, useTheme } from "@mui/material";
import Select from "react-select";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { loadShopSpecialPriceBranches, loadShopSpecialPriceFilterOptions, loadShopSpecialPriceProducts, saveShopSpecialPrice } from "../../redux/handlers/manage/shopSpecialPrice.handler";
import { resetShopSpecialPriceState } from "../../redux/slices/manage/shopSpecialPrice.slice";
import "../../styles/shopSpecialPrice.css";
var PAGE_SIZE = 30;
var BRANCH_PAGE_SIZE = 10;
var VAT_MULTIPLIER = 1.1;
var pageResultFrom = function(result) {
    result = result !== null && result !== void 0 ? result : {};
    if (Array.isArray(result)) return {
        data: result,
        pagination: {}
    };
    var _result_pagination;
    return {
        data: Array.isArray(result === null || result === void 0 ? void 0 : result.data) ? result.data : [],
        pagination: (_result_pagination = result === null || result === void 0 ? void 0 : result.pagination) !== null && _result_pagination !== void 0 ? _result_pagination : {}
    };
};
var money = function(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return "-";
    return amount.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
var getProductName = function(product) {
    var _product_PdProduct, _product_PdProduct1;
    return (product === null || product === void 0 ? void 0 : (_product_PdProduct = product.PdProduct) === null || _product_PdProduct === void 0 ? void 0 : _product_PdProduct.pd_product_nameth) || (product === null || product === void 0 ? void 0 : (_product_PdProduct1 = product.PdProduct) === null || _product_PdProduct1 === void 0 ? void 0 : _product_PdProduct1.pd_product_nameen) || "สินค้าไม่มีชื่อ";
};
var getProductDetails = function(product) {
    if (Array.isArray(product === null || product === void 0 ? void 0 : product.details)) return product.details;
    return (product === null || product === void 0 ? void 0 : product.pd_pdetail_id) ? [
        product
    ] : [];
};
var hasSpecialPrice = function(product) {
    return getProductDetails(product).some(function(detail) {
        return detail.specialPrice !== null && detail.specialPrice !== undefined;
    });
};
var getUnitLabel = function(detail) {
    var _detail_SetUnit;
    var unitName = (detail === null || detail === void 0 ? void 0 : (_detail_SetUnit = detail.SetUnit) === null || _detail_SetUnit === void 0 ? void 0 : _detail_SetUnit.set_unit_name) || "หน่วย";
    return "".concat(unitName).concat((detail === null || detail === void 0 ? void 0 : detail.pd_pdetail_ratio) ? " / ".concat(detail.pd_pdetail_ratio) : "");
};
var Pager = function(param) {
    var pagination = param.pagination, page = param.page, onPageChange = param.onPageChange, loading = param.loading;
    var total = Number(pagination.total) || 0;
    var pageSize = Number(pagination.pageSize) || PAGE_SIZE;
    var totalPages = Math.max(Number(pagination.totalPages) || 1, 1);
    var start = total ? (page - 1) * pageSize + 1 : 0;
    var end = Math.min(page * pageSize, total);
    return /*#__PURE__*/ _jsxs("div", {
        className: "sp-pager",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "text-muted small",
                children: [
                    "แสดง ",
                    start,
                    "–",
                    end,
                    " จาก ",
                    total,
                    " รายการ"
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        size: "sm",
                        disabled: page <= 1 || loading,
                        onClick: function() {
                            return onPageChange(Math.max(page - 1, 1));
                        },
                        children: "ก่อนหน้า"
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "small text-nowrap",
                        children: [
                            "หน้า ",
                            page,
                            " / ",
                            totalPages
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        size: "sm",
                        disabled: page >= totalPages || loading,
                        onClick: function() {
                            return onPageChange(Math.min(page + 1, totalPages));
                        },
                        children: "ถัดไป"
                    })
                ]
            })
        ]
    });
};
var ProductIdentity = function(param) {
    var product = param.product;
    var _product_PdProduct, _product_PdProduct1, _product_PdProduct2;
    var image = product === null || product === void 0 ? void 0 : (_product_PdProduct = product.PdProduct) === null || _product_PdProduct === void 0 ? void 0 : _product_PdProduct.pd_product_image;
    return /*#__PURE__*/ _jsxs("div", {
        className: "sp-product-identity",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "sp-product-image-wrap",
                children: image ? /*#__PURE__*/ _jsx("img", {
                    className: "sp-product-image",
                    src: image,
                    alt: "",
                    loading: "lazy",
                    onError: function(event) {
                        event.currentTarget.style.display = "none";
                    }
                }) : /*#__PURE__*/ _jsx("span", {
                    className: "sp-product-image-fallback",
                    children: "สินค้า"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "sp-product-name-wrap",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "fw-semibold text-break",
                        children: getProductName(product)
                    }),
                    (product === null || product === void 0 ? void 0 : (_product_PdProduct1 = product.PdProduct) === null || _product_PdProduct1 === void 0 ? void 0 : _product_PdProduct1.pd_product_nameen) && product.PdProduct.pd_product_nameth && product.PdProduct.pd_product_nameen !== product.PdProduct.pd_product_nameth && /*#__PURE__*/ _jsx("div", {
                        className: "small text-muted text-break",
                        children: product.PdProduct.pd_product_nameen
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "small text-muted",
                        children: [
                            "รหัสสินค้า: ",
                            (product === null || product === void 0 ? void 0 : (_product_PdProduct2 = product.PdProduct) === null || _product_PdProduct2 === void 0 ? void 0 : _product_PdProduct2.pd_product_code) || "-"
                        ]
                    })
                ]
            })
        ]
    });
};
var SpecialPrice = function(param) {
    var value = param.value;
    return /*#__PURE__*/ _jsxs("div", {
        className: "sp-price-lines",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: "Ex VAT"
                    }),
                    /*#__PURE__*/ _jsx("strong", {
                        children: money(value)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: "In VAT"
                    }),
                    /*#__PURE__*/ _jsx("strong", {
                        children: money(Number(value) * VAT_MULTIPLIER)
                    })
                ]
            })
        ]
    });
};
export default function ShopSpecialPrice() {
    var _selectedBranch_sysUser;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState({
        shopId: "",
        branchId: "",
        adminId: ""
    }), 2), branchFiltersInput = _useState[0], setBranchFiltersInput = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        shopId: "",
        branchId: "",
        adminId: ""
    }), 2), branchFilters = _useState1[0], setBranchFilters = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), branchPage = _useState2[0], setBranchPage = _useState2[1];
    var _useState3 = _sliced_to_array(useState(BRANCH_PAGE_SIZE), 2), branchPageSize = _useState3[0], setBranchPageSize = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), selectedBranchId = _useState4[0], setSelectedBranchId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), productSearchInput = _useState5[0], setProductSearchInput = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), productSearch = _useState6[0], setProductSearch = _useState6[1];
    var _useState7 = _sliced_to_array(useState(1), 2), productPage = _useState7[0], setProductPage = _useState7[1];
    var _useState8 = _sliced_to_array(useState(null), 2), modalMode = _useState8[0], setModalMode = _useState8[1];
    var _useState9 = _sliced_to_array(useState(false), 2), returnToPicker = _useState9[0], setReturnToPicker = _useState9[1];
    var _useState10 = _sliced_to_array(useState(""), 2), candidateSearchInput = _useState10[0], setCandidateSearchInput = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), candidateSearch = _useState11[0], setCandidateSearch = _useState11[1];
    var _useState12 = _sliced_to_array(useState(null), 2), candidateBrandInput = _useState12[0], setCandidateBrandInput = _useState12[1];
    var _useState13 = _sliced_to_array(useState(null), 2), candidateBrandId = _useState13[0], setCandidateBrandId = _useState13[1];
    var _useState14 = _sliced_to_array(useState(1), 2), candidatePage = _useState14[0], setCandidatePage = _useState14[1];
    var _useState15 = _sliced_to_array(useState(null), 2), selectedProduct = _useState15[0], setSelectedProduct = _useState15[1];
    var _useState16 = _sliced_to_array(useState({}), 2), priceInputs = _useState16[0], setPriceInputs = _useState16[1];
    var _useState17 = _sliced_to_array(useState(null), 2), notice = _useState17[0], setNotice = _useState17[1];
    var specialPriceState = useAppSelector(function(state) {
        return state.shopSpecialPriceReducer;
    });
    var filterOptionsState = specialPriceState.filterOptions;
    var branchesState = specialPriceState.branches;
    var configuredProductsState = specialPriceState.configuredProducts;
    var candidateProductsState = specialPriceState.candidateProducts;
    var saveState = specialPriceState.save;
    var filterOptions = filterOptionsState.data || {
        branches: [],
        sales: []
    };
    var brandOptions = useMemo(function() {
        return Array.isArray(filterOptions.brands) ? filterOptions.brands.map(function(brand) {
            return {
                value: Number(brand.set_brand_id),
                label: brand.set_brand_name || brand.set_brand_nameen || String(brand.set_brand_id)
            };
        }) : [];
    }, [
        filterOptions.brands
    ]);
    var filterBranches = Array.isArray(filterOptions.branches) ? filterOptions.branches : [];
    var filterShopOptions = useMemo(function() {
        var shopMap = new Map();
        filterBranches.forEach(function(branch) {
            var shop = branch.shShop;
            var shopId = Number(branch.sh_branch_shid);
            if ((shop === null || shop === void 0 ? void 0 : shop.sh_shop_name) && shopId && !shopMap.has(shopId)) {
                shopMap.set(shopId, {
                    value: shopId,
                    label: shop.sh_shop_code ? "".concat(shop.sh_shop_name, " (").concat(shop.sh_shop_code, ")") : shop.sh_shop_name
                });
            }
        });
        return Array.from(shopMap.values());
    }, [
        filterBranches
    ]);
    var filterSaleOptions = useMemo(function() {
        return Array.isArray(filterOptions.sales) ? filterOptions.sales.map(function(sale) {
            return {
                value: Number(sale.sys_user_id),
                label: sale.sys_user_fullname || "ผู้ดูแล #".concat(sale.sys_user_id)
            };
        }) : [];
    }, [
        filterOptions.sales
    ]);
    var branchResult = pageResultFrom(branchesState.data);
    var branches = branchResult.data;
    var branchPagination = _object_spread_props(_object_spread({}, branchResult.pagination), {
        page: branchPage,
        pageSize: branchPageSize,
        total: Number(branchResult.pagination.total) || 0,
        totalPages: Number(branchResult.pagination.totalPages) || 1
    });
    var branchesLoading = branchesState.isFetching;
    var branchError = branchesState.error;
    var configuredProductResult = pageResultFrom(configuredProductsState.data);
    var products = configuredProductResult.data;
    var productPagination = configuredProductResult.pagination;
    var productsLoading = configuredProductsState.isFetching;
    var detailError = configuredProductsState.error;
    var candidateProductResult = pageResultFrom(candidateProductsState.data);
    var candidateProducts = candidateProductResult.data;
    var candidatePagination = candidateProductResult.pagination;
    var candidateLoading = candidateProductsState.isFetching;
    var candidateError = candidateProductsState.error;
    var saving = saveState.isFetching;
    var filterOptionsLoading = filterOptionsState.isFetching;
    var filterOptionsError = filterOptionsState.error;
    var selectedBranch = useMemo(function() {
        return branches.find(function(branch) {
            return Number(branch.sh_branch_id) === Number(selectedBranchId);
        }) || null;
    }, [
        branches,
        selectedBranchId
    ]);
    var branchSelectOptions = useMemo(function() {
        var shopId = Number(branchFiltersInput.shopId);
        return filterBranches.filter(function(branch) {
            return !shopId || Number(branch.sh_branch_shid) === shopId;
        }).map(function(branch) {
            var _branch_shShop;
            return {
                value: branch.sh_branch_id,
                label: "".concat(branch.sh_branch_name || "สาขา").concat(branch.sh_branch_code ? " (".concat(branch.sh_branch_code, ")") : "", " \xb7 ").concat(((_branch_shShop = branch.shShop) === null || _branch_shShop === void 0 ? void 0 : _branch_shShop.sh_shop_name) || "ร้านค้า")
            };
        });
    }, [
        branchFiltersInput.shopId,
        filterBranches
    ]);
    var loadFilterOptions = useCallback(function() {
        return dispatch(loadShopSpecialPriceFilterOptions());
    }, [
        dispatch
    ]);
    useEffect(function() {
        dispatch(resetShopSpecialPriceState());
        loadFilterOptions();
    }, [
        dispatch,
        loadFilterOptions
    ]);
    var loadBranches = useCallback(function() {
        return dispatch(loadShopSpecialPriceBranches(_object_spread_props(_object_spread({}, branchFilters), {
            page: branchPage,
            pageSize: branchPageSize
        })));
    }, [
        branchFilters,
        branchPage,
        branchPageSize,
        dispatch
    ]);
    useEffect(function() {
        loadBranches();
    }, [
        loadBranches
    ]);
    var loadConfiguredProducts = useCallback(function() {
        if (!selectedBranchId) return Promise.resolve({
            success: false
        });
        return dispatch(loadShopSpecialPriceProducts({
            branchId: Number(selectedBranchId),
            search: productSearch,
            page: productPage,
            pageSize: PAGE_SIZE,
            configuredOnly: true
        }, "configuredProducts"));
    }, [
        dispatch,
        productPage,
        productSearch,
        selectedBranchId
    ]);
    useEffect(function() {
        if (selectedBranchId) loadConfiguredProducts();
    }, [
        loadConfiguredProducts,
        selectedBranchId
    ]);
    var loadCandidateProducts = useCallback(function() {
        if (!selectedBranchId || modalMode !== "picker") return Promise.resolve({
            success: false
        });
        return dispatch(loadShopSpecialPriceProducts({
            branchId: Number(selectedBranchId),
            search: candidateSearch,
            brandId: candidateBrandId,
            page: candidatePage,
            pageSize: PAGE_SIZE,
            configuredOnly: false
        }, "candidateProducts"));
    }, [
        candidatePage,
        candidateSearch,
        candidateBrandId,
        dispatch,
        modalMode,
        selectedBranchId
    ]);
    useEffect(function() {
        loadCandidateProducts();
    }, [
        loadCandidateProducts
    ]);
    var applyBranchFilters = function(event) {
        event.preventDefault();
        setBranchPage(1);
        setBranchFilters({
            shopId: branchFiltersInput.shopId ? Number(branchFiltersInput.shopId) : "",
            branchId: branchFiltersInput.branchId ? Number(branchFiltersInput.branchId) : "",
            adminId: branchFiltersInput.adminId ? Number(branchFiltersInput.adminId) : ""
        });
    };
    var changeBranchPageSize = function(pageSize) {
        setBranchPageSize(pageSize);
        setBranchPage(1);
    };
    var openBranch = function(branch) {
        setSelectedBranchId(branch.sh_branch_id);
        setProductSearchInput("");
        setProductSearch("");
        setProductPage(1);
        setNotice(null);
    };
    var goBackToBranches = function() {
        setSelectedBranchId(null);
        setNotice(null);
    };
    var submitProductSearch = function(event) {
        event.preventDefault();
        setProductPage(1);
        setProductSearch(productSearchInput.trim());
    };
    var openPicker = function() {
        setCandidateBrandInput(null);
        setCandidateBrandId(null);
        setCandidateSearchInput("");
        setCandidateSearch("");
        setCandidatePage(1);
        setModalMode("picker");
        setNotice(null);
    };
    var closeModal = function() {
        if (saving) return;
        setModalMode(null);
        setSelectedProduct(null);
        setReturnToPicker(false);
    };
    var openPriceEditor = function(product) {
        var shouldReturnToPicker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setSelectedProduct(product);
        setPriceInputs(Object.fromEntries(getProductDetails(product).map(function(detail) {
            return [
                detail.pd_pdetail_id,
                detail.specialPrice === null || detail.specialPrice === undefined ? "" : String(detail.specialPrice)
            ];
        })));
        setReturnToPicker(shouldReturnToPicker);
        setNotice(null);
        setModalMode("editor");
    };
    var cancelPriceEditor = function() {
        if (returnToPicker) {
            setModalMode("picker");
            return;
        }
        closeModal();
    };
    var submitCandidateSearch = function(event) {
        event.preventDefault();
        setCandidatePage(1);
        setCandidateSearch(candidateSearchInput.trim());
        setCandidateBrandId((candidateBrandInput === null || candidateBrandInput === void 0 ? void 0 : candidateBrandInput.value) || null);
    };
    var savePrice = function() {
        var _ref = _async_to_generator(function(event) {
            var details, items, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        details = getProductDetails(selectedProduct);
                        items = details.map(function(detail) {
                            return {
                                pdetailId: Number(detail.pd_pdetail_id),
                                specialPrice: Number(priceInputs[detail.pd_pdetail_id])
                            };
                        });
                        if (!selectedProduct || !items.length || items.some(function(item, index) {
                            var _priceInputs_details_index_pd_pdetail_id;
                            return String((_priceInputs_details_index_pd_pdetail_id = priceInputs[details[index].pd_pdetail_id]) !== null && _priceInputs_details_index_pd_pdetail_id !== void 0 ? _priceInputs_details_index_pd_pdetail_id : "").trim() === "" || !Number.isFinite(item.specialPrice) || item.specialPrice < 0;
                        })) {
                            setNotice({
                                type: "warning",
                                text: "กรุณาระบุราคาพิเศษให้ครบทุกหน่วย เป็นตัวเลขตั้งแต่ 0 ขึ้นไป"
                            });
                            return [
                                2
                            ];
                        }
                        setNotice(null);
                        return [
                            4,
                            dispatch(saveShopSpecialPrice({
                                branchId: Number(selectedBranchId),
                                items: items
                            }))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result.success) {
                            setNotice({
                                type: "danger",
                                text: result.error || "บันทึกไม่สำเร็จ กรุณาตรวจสอบราคาแล้วลองอีกครั้ง"
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            loadConfiguredProducts()
                        ];
                    case 2:
                        _state.sent();
                        if (returnToPicker) {
                            setModalMode("picker");
                            setNotice({
                                type: "success",
                                text: "บันทึกราคาพิเศษสินค้าแล้ว"
                            });
                        } else {
                            setModalMode(null);
                            setSelectedProduct(null);
                            setReturnToPicker(false);
                            setNotice({
                                type: "success",
                                text: "บันทึกราคาพิเศษสินค้าแล้ว"
                            });
                        }
                        loadBranches();
                        return [
                            2
                        ];
                }
            });
        });
        return function savePrice(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var deletePrice = function() {
        var _ref = _async_to_generator(function(product) {
            var name, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = getProductName(product);
                        if (!window.confirm("ต้องการนำ “".concat(name, "” ออกจากรายการราคาพิเศษของสาขานี้หรือไม่?"))) return [
                            2
                        ];
                        setNotice(null);
                        return [
                            4,
                            dispatch(saveShopSpecialPrice({
                                branchId: Number(selectedBranchId),
                                items: getProductDetails(product).map(function(detail) {
                                    return {
                                        pdetailId: Number(detail.pd_pdetail_id),
                                        specialPrice: null
                                    };
                                })
                            }))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result.success) {
                            setNotice({
                                type: "danger",
                                text: result.error || "ลบรายการไม่สำเร็จ กรุณาลองอีกครั้ง"
                            });
                            return [
                                2
                            ];
                        }
                        if (!(products.length === 1 && productPage > 1)) return [
                            3,
                            2
                        ];
                        setProductPage(function(page) {
                            return Math.max(page - 1, 1);
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            loadConfiguredProducts()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        loadBranches();
                        setNotice({
                            type: "success",
                            text: "นำสินค้าออกจากรายการราคาพิเศษแล้ว"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function deletePrice(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var branchName = function(branch) {
        var _branch_shShop;
        return "".concat((branch === null || branch === void 0 ? void 0 : (_branch_shShop = branch.shShop) === null || _branch_shShop === void 0 ? void 0 : _branch_shShop.sh_shop_name) || "ร้านค้า", " / ").concat((branch === null || branch === void 0 ? void 0 : branch.sh_branch_name) || "สาขา");
    };
    var detailTitle = selectedBranch ? branchName(selectedBranch) : "";
    var branchColumns = [
        {
            name: "ร้านค้า",
            selector: function(row) {
                var _row_shShop;
                return ((_row_shShop = row.shShop) === null || _row_shShop === void 0 ? void 0 : _row_shShop.sh_shop_name) || "-";
            },
            cell: function(row) {
                var _row_shShop, _row_shShop1;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "py-1",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: ((_row_shShop = row.shShop) === null || _row_shShop === void 0 ? void 0 : _row_shShop.sh_shop_name) || "-"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-12 tc-7",
                            children: ((_row_shShop1 = row.shShop) === null || _row_shShop1 === void 0 ? void 0 : _row_shShop1.sh_shop_code) || "-"
                        })
                    ]
                });
            }
        },
        {
            name: "สาขา",
            selector: function(row) {
                return row.sh_branch_name || "-";
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "py-1",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.sh_branch_name || "-"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-12 tc-7",
                            children: row.sh_branch_code || "-"
                        })
                    ]
                });
            }
        },
        {
            name: "ระดับสาขา",
            selector: function(row) {
                return row.sh_branch_grade || 1;
            },
            center: true,
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("span", {
                    className: "badge bg-light text-dark border",
                    children: [
                        "Level ",
                        row.sh_branch_grade || 1
                    ]
                });
            }
        },
        {
            name: "ผู้ดูแล",
            selector: function(row) {
                var _row_sysUser;
                return ((_row_sysUser = row.sysUser) === null || _row_sysUser === void 0 ? void 0 : _row_sysUser.sys_user_fullname) || "-";
            }
        },
        {
            name: "สินค้าที่ตั้งราคา",
            selector: function(row) {
                return Number(row.specialPriceProductCount) || 0;
            },
            center: true
        },
        {
            name: "จัดการ",
            center: true,
            width: "130px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Button, {
                    size: "sm",
                    className: "btn-dg",
                    onClick: function() {
                        return openBranch(row);
                    },
                    children: "แก้ไข"
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "shop-special-price-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "pagezoom" : "",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: !isMobile ? "breadcrumb fs-16 ps-0 mb-1" : "breadcrumb fs-14 ps-2 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item active",
                                    "aria-current": "page",
                                    children: "จัดการราคาพิเศษสินค้าแยกตามสาขา"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2 ps-2",
                        children: "จัดการราคาพิเศษสินค้าแยกตามสาขา"
                    })
                ]
            }),
            notice && /*#__PURE__*/ _jsx("div", {
                className: "alert alert-".concat(notice.type, " py-2"),
                role: "alert",
                children: notice.text
            }),
            !selectedBranch ? /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsxs(Card.Body, {
                        children: [
                            /*#__PURE__*/ _jsx(Form, {
                                onSubmit: applyBranchFilters,
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    className: "g-2 align-items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 3,
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "form-st-3 p-0",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 z-3",
                                                        children: "ค้นหาร้านค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        className: "w-100 select-st-3 z-2",
                                                        placeholder: "ค้นหาร้านค้า",
                                                        options: filterShopOptions,
                                                        value: filterShopOptions.find(function(option) {
                                                            return Number(option.value) === Number(branchFiltersInput.shopId);
                                                        }) || null,
                                                        onChange: function(option) {
                                                            return setBranchFiltersInput(function(value) {
                                                                return _object_spread_props(_object_spread({}, value), {
                                                                    shopId: (option === null || option === void 0 ? void 0 : option.value) || "",
                                                                    branchId: ""
                                                                });
                                                            });
                                                        },
                                                        isClearable: true,
                                                        isLoading: filterOptionsLoading,
                                                        noOptionsMessage: function() {
                                                            return "ไม่พบร้านค้า";
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 3,
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "form-st-3 p-0",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 z-3",
                                                        children: "ค้นหาสาขา"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        className: "w-100 select-st-3 z-2",
                                                        placeholder: "ค้นหาสาขา",
                                                        options: branchSelectOptions,
                                                        value: branchSelectOptions.find(function(option) {
                                                            return Number(option.value) === Number(branchFiltersInput.branchId);
                                                        }) || null,
                                                        onChange: function(option) {
                                                            return setBranchFiltersInput(function(value) {
                                                                return _object_spread_props(_object_spread({}, value), {
                                                                    branchId: (option === null || option === void 0 ? void 0 : option.value) || ""
                                                                });
                                                            });
                                                        },
                                                        isClearable: true,
                                                        isLoading: filterOptionsLoading,
                                                        noOptionsMessage: function() {
                                                            return "ไม่พบสาขา";
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 3,
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "form-st-3 p-0",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 z-3",
                                                        children: "ค้นหาผู้ดูแล"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        className: "w-100 select-st-3 z-2",
                                                        placeholder: "ค้นหาผู้ดูแล",
                                                        options: filterSaleOptions,
                                                        value: filterSaleOptions.find(function(option) {
                                                            return Number(option.value) === Number(branchFiltersInput.adminId);
                                                        }) || null,
                                                        onChange: function(option) {
                                                            return setBranchFiltersInput(function(value) {
                                                                return _object_spread_props(_object_spread({}, value), {
                                                                    adminId: (option === null || option === void 0 ? void 0 : option.value) || ""
                                                                });
                                                            });
                                                        },
                                                        isClearable: true,
                                                        isLoading: filterOptionsLoading,
                                                        noOptionsMessage: function() {
                                                            return "ไม่พบผู้ดูแล";
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 3,
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "btn btn-dg w-100",
                                                type: "submit",
                                                children: "ค้นหา"
                                            })
                                        })
                                    ]
                                })
                            }),
                            filterOptionsError && /*#__PURE__*/ _jsx("div", {
                                className: "alert alert-danger mb-0 mt-3",
                                children: filterOptionsError
                            })
                        ]
                    }),
                    branchError && /*#__PURE__*/ _jsx("div", {
                        className: "alert alert-danger mx-3 mt-2 mb-0",
                        role: "alert",
                        children: branchError
                    }),
                    /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                        item: branches,
                        columns: branchColumns,
                        isSelectRows: false,
                        currentPage: branchPage,
                        currentPageSize: branchPageSize,
                        onChangePage: setBranchPage,
                        onChangePageSize: changeBranchPageSize,
                        totalPage: branchPagination.totalPages || 1,
                        totalAmount: branchPagination.total || 0,
                        loading: branchesLoading
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2 mb-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex align-items-start gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline-secondary",
                                        onClick: goBackToBranches,
                                        children: "กลับ"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ _jsx("h2", {
                                                className: "h5 mb-1 text-break",
                                                children: detailTitle
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "small text-muted",
                                                children: [
                                                    (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.sh_branch_code) || "-",
                                                    " \xb7 Level ",
                                                    (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.sh_branch_grade) || 1,
                                                    " \xb7 ",
                                                    (selectedBranch === null || selectedBranch === void 0 ? void 0 : (_selectedBranch_sysUser = selectedBranch.sysUser) === null || _selectedBranch_sysUser === void 0 ? void 0 : _selectedBranch_sysUser.sys_user_fullname) || "ไม่มีผู้ดูแล"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                className: "btn-dg px-3",
                                onClick: openPicker,
                                children: "เพิ่มสินค้า"
                            })
                        ]
                    }),
                    detailError && /*#__PURE__*/ _jsx("div", {
                        className: "alert alert-danger py-2",
                        children: detailError
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        className: "border-0 shadow-sm",
                        children: [
                            /*#__PURE__*/ _jsx(Card.Body, {
                                className: "pb-2",
                                children: /*#__PURE__*/ _jsx(Form, {
                                    onSubmit: submitProductSearch,
                                    children: /*#__PURE__*/ _jsxs(Row, {
                                        className: "g-2 align-items-end",
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 8,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            children: "ค้นหาสินค้าที่ตั้งราคาพิเศษแล้ว"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            value: productSearchInput,
                                                            onChange: function(event) {
                                                                return setProductSearchInput(event.target.value);
                                                            },
                                                            placeholder: "ชื่อสินค้า รหัสสินค้า หรือบาร์โค้ด"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 4,
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-dg w-100",
                                                    type: "submit",
                                                    children: "ค้นหา"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Card.Body, {
                                className: "p-0",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "table-responsive d-none d-lg-block",
                                        children: /*#__PURE__*/ _jsxs("table", {
                                            className: "table table-hover align-middle mb-0 sp-table sp-product-table",
                                            children: [
                                                /*#__PURE__*/ _jsx("thead", {
                                                    children: /*#__PURE__*/ _jsxs("tr", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("th", {
                                                                children: "สินค้า"
                                                            }),
                                                            /*#__PURE__*/ _jsx("th", {
                                                                children: "หน่วยสินค้า / บาร์โค้ด"
                                                            }),
                                                            /*#__PURE__*/ _jsx("th", {
                                                                className: "text-end",
                                                                children: "ราคาแนะนำ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("th", {
                                                                children: "ราคาพิเศษ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("th", {
                                                                className: "text-center",
                                                                children: "จัดการ"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("tbody", {
                                                    children: productsLoading ? /*#__PURE__*/ _jsx("tr", {
                                                        children: /*#__PURE__*/ _jsxs("td", {
                                                            colSpan: "5",
                                                            className: "text-center py-5",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Spinner, {
                                                                    size: "sm",
                                                                    className: "me-2"
                                                                }),
                                                                "กำลังโหลดสินค้า..."
                                                            ]
                                                        })
                                                    }) : products.length ? products.map(function(product) {
                                                        return /*#__PURE__*/ _jsxs("tr", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(ProductIdentity, {
                                                                        product: product
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "sp-unit-list",
                                                                        children: getProductDetails(product).map(function(detail) {
                                                                            return /*#__PURE__*/ _jsxs("div", {
                                                                                className: "sp-unit-list-row",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                                        children: getUnitLabel(detail)
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        children: detail.pd_pdetail_barcode || "-"
                                                                                    })
                                                                                ]
                                                                            }, detail.pd_pdetail_id);
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "text-end",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "sp-unit-list sp-unit-list-end",
                                                                        children: getProductDetails(product).map(function(detail) {
                                                                            return /*#__PURE__*/ _jsx("div", {
                                                                                className: "sp-unit-list-row",
                                                                                children: money(detail.pd_pdetail_recommentprice)
                                                                            }, detail.pd_pdetail_id);
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "sp-unit-list",
                                                                        children: getProductDetails(product).map(function(detail) {
                                                                            return /*#__PURE__*/ _jsx("div", {
                                                                                className: "sp-unit-list-row",
                                                                                children: detail.specialPrice === null || detail.specialPrice === undefined ? /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-muted",
                                                                                    children: "ยังไม่ตั้งราคา"
                                                                                }) : /*#__PURE__*/ _jsx(SpecialPrice, {
                                                                                    value: detail.specialPrice
                                                                                })
                                                                            }, detail.pd_pdetail_id);
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex justify-content-center gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Button, {
                                                                                size: "sm",
                                                                                variant: "outline-primary",
                                                                                onClick: function() {
                                                                                    return openPriceEditor(product);
                                                                                },
                                                                                children: "แก้ไขราคา"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Button, {
                                                                                size: "sm",
                                                                                variant: "outline-danger",
                                                                                onClick: function() {
                                                                                    return deletePrice(product);
                                                                                },
                                                                                children: "ลบ"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }, product.pd_product_id);
                                                    }) : /*#__PURE__*/ _jsx("tr", {
                                                        children: /*#__PURE__*/ _jsx("td", {
                                                            colSpan: "5",
                                                            className: "text-center text-muted py-5",
                                                            children: productSearch ? "ไม่พบสินค้าที่ค้นหา" : "ยังไม่มีสินค้าที่ตั้งราคาพิเศษ"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "d-lg-none p-3",
                                        children: productsLoading ? /*#__PURE__*/ _jsxs("div", {
                                            className: "text-center py-5",
                                            children: [
                                                /*#__PURE__*/ _jsx(Spinner, {
                                                    size: "sm",
                                                    className: "me-2"
                                                }),
                                                "กำลังโหลดสินค้า..."
                                            ]
                                        }) : products.length ? /*#__PURE__*/ _jsx("div", {
                                            className: "d-grid gap-3",
                                            children: products.map(function(product) {
                                                return /*#__PURE__*/ _jsxs("div", {
                                                    className: "sp-configured-product",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(ProductIdentity, {
                                                            product: product
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "sp-mobile-unit-list",
                                                            children: getProductDetails(product).map(function(detail) {
                                                                return /*#__PURE__*/ _jsxs("div", {
                                                                    className: "sp-mobile-unit",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "d-flex justify-content-between gap-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("strong", {
                                                                                    children: getUnitLabel(detail)
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-muted text-end",
                                                                                    children: detail.pd_pdetail_barcode || "-"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "sp-mobile-unit-values",
                                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        children: "ราคาแนะนำ"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                                        children: money(detail.pd_pdetail_recommentprice)
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "sp-mobile-price-row",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: "ราคาพิเศษ"
                                                                                }),
                                                                                detail.specialPrice === null || detail.specialPrice === undefined ? /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-muted",
                                                                                    children: "ยังไม่ตั้งราคา"
                                                                                }) : /*#__PURE__*/ _jsx(SpecialPrice, {
                                                                                    value: detail.specialPrice
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, detail.pd_pdetail_id);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "d-flex gap-2 mt-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    size: "sm",
                                                                    variant: "outline-primary",
                                                                    className: "flex-fill",
                                                                    onClick: function() {
                                                                        return openPriceEditor(product);
                                                                    },
                                                                    children: "แก้ไขราคา"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    size: "sm",
                                                                    variant: "outline-danger",
                                                                    className: "flex-fill",
                                                                    onClick: function() {
                                                                        return deletePrice(product);
                                                                    },
                                                                    children: "ลบ"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, product.pd_product_id);
                                            })
                                        }) : /*#__PURE__*/ _jsx("div", {
                                            className: "text-center text-muted py-4",
                                            children: productSearch ? "ไม่พบสินค้าที่ค้นหา" : "ยังไม่มีสินค้าที่ตั้งราคาพิเศษ"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "px-3 pb-3",
                                        children: /*#__PURE__*/ _jsx(Pager, {
                                            pagination: productPagination,
                                            page: productPage,
                                            onPageChange: setProductPage,
                                            loading: productsLoading
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Modal, {
                show: Boolean(modalMode),
                onHide: closeModal,
                size: modalMode === "picker" ? "xl" : "lg",
                centered: true,
                scrollable: true,
                fullscreen: "md-down",
                className: "shop-special-price-modal",
                children: modalMode === "picker" ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Modal.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ _jsxs(Modal.Title, {
                                className: "h5",
                                children: [
                                    "เพิ่มสินค้าราคาพิเศษ \xb7 ",
                                    detailTitle
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Modal.Body, {
                            children: [
                                notice && /*#__PURE__*/ _jsx("div", {
                                    className: "alert alert-".concat(notice.type, " py-2"),
                                    role: "alert",
                                    children: notice.text
                                }),
                                candidateError && /*#__PURE__*/ _jsx("div", {
                                    className: "alert alert-danger py-2",
                                    role: "alert",
                                    children: candidateError
                                }),
                                /*#__PURE__*/ _jsx(Form, {
                                    onSubmit: submitCandidateSearch,
                                    className: "mb-3",
                                    children: /*#__PURE__*/ _jsxs(Row, {
                                        className: "g-2 align-items-end",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 4,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        htmlFor: "special-price-brand",
                                                        children: "แบรนด์"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        inputId: "special-price-brand",
                                                        "aria-label": "แบรนด์",
                                                        options: brandOptions,
                                                        value: candidateBrandInput,
                                                        onChange: setCandidateBrandInput,
                                                        placeholder: "ทุกแบรนด์",
                                                        isClearable: true,
                                                        isLoading: filterOptionsLoading,
                                                        noOptionsMessage: function() {
                                                            return "ไม่พบแบรนด์";
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 5,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        children: "ค้นหาสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        value: candidateSearchInput,
                                                        onChange: function(event) {
                                                            return setCandidateSearchInput(event.target.value);
                                                        },
                                                        placeholder: "ค้นหาชื่อสินค้า รหัสสินค้า หรือบาร์โค้ด"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 3,
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-dg w-100",
                                                    type: "submit",
                                                    children: "ค้นหา"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-responsive d-none d-md-block",
                                    children: /*#__PURE__*/ _jsxs("table", {
                                        className: "table table-hover align-middle sp-table sp-candidate-table",
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "สินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "หน่วยสินค้า / บาร์โค้ด"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            className: "text-end",
                                                            children: "ราคาแนะนำ"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ราคาพิเศษปัจจุบัน"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            className: "text-center",
                                                            children: "เลือก"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: candidateLoading ? /*#__PURE__*/ _jsx("tr", {
                                                    children: /*#__PURE__*/ _jsxs("td", {
                                                        colSpan: "5",
                                                        className: "text-center py-5",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Spinner, {
                                                                size: "sm",
                                                                className: "me-2"
                                                            }),
                                                            "กำลังโหลดสินค้า..."
                                                        ]
                                                    })
                                                }) : candidateProducts.length ? candidateProducts.map(function(product) {
                                                    return /*#__PURE__*/ _jsxs("tr", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: /*#__PURE__*/ _jsx(ProductIdentity, {
                                                                    product: product
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "sp-unit-list",
                                                                    children: getProductDetails(product).map(function(detail) {
                                                                        return /*#__PURE__*/ _jsxs("div", {
                                                                            className: "sp-unit-list-row",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("strong", {
                                                                                    children: getUnitLabel(detail)
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: detail.pd_pdetail_barcode || "-"
                                                                                })
                                                                            ]
                                                                        }, detail.pd_pdetail_id);
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "text-end",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "sp-unit-list sp-unit-list-end",
                                                                    children: getProductDetails(product).map(function(detail) {
                                                                        return /*#__PURE__*/ _jsx("div", {
                                                                            className: "sp-unit-list-row",
                                                                            children: money(detail.pd_pdetail_recommentprice)
                                                                        }, detail.pd_pdetail_id);
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "sp-unit-list",
                                                                    children: getProductDetails(product).map(function(detail) {
                                                                        return /*#__PURE__*/ _jsx("div", {
                                                                            className: "sp-unit-list-row",
                                                                            children: detail.specialPrice === null || detail.specialPrice === undefined ? /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-muted",
                                                                                children: "ยังไม่ตั้งราคา"
                                                                            }) : /*#__PURE__*/ _jsx(SpecialPrice, {
                                                                                value: detail.specialPrice
                                                                            })
                                                                        }, detail.pd_pdetail_id);
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "text-center",
                                                                children: /*#__PURE__*/ _jsx(Button, {
                                                                    size: "sm",
                                                                    variant: hasSpecialPrice(product) ? "outline-primary" : "primary",
                                                                    onClick: function() {
                                                                        return openPriceEditor(product, true);
                                                                    },
                                                                    children: hasSpecialPrice(product) ? "แก้ไขราคา" : "เพิ่มสินค้า"
                                                                })
                                                            })
                                                        ]
                                                    }, product.pd_product_id);
                                                }) : /*#__PURE__*/ _jsx("tr", {
                                                    children: /*#__PURE__*/ _jsx("td", {
                                                        colSpan: "5",
                                                        className: "text-center text-muted py-5",
                                                        children: "ไม่พบสินค้าใช้งาน"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "d-md-none d-grid gap-3",
                                    children: [
                                        candidateLoading ? /*#__PURE__*/ _jsxs("div", {
                                            className: "text-center py-5",
                                            children: [
                                                /*#__PURE__*/ _jsx(Spinner, {
                                                    size: "sm",
                                                    className: "me-2"
                                                }),
                                                "กำลังโหลดสินค้า..."
                                            ]
                                        }) : candidateProducts.map(function(product) {
                                            return /*#__PURE__*/ _jsxs("div", {
                                                className: "sp-configured-product",
                                                children: [
                                                    /*#__PURE__*/ _jsx(ProductIdentity, {
                                                        product: product
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "sp-mobile-unit-list",
                                                        children: getProductDetails(product).map(function(detail) {
                                                            return /*#__PURE__*/ _jsxs("div", {
                                                                className: "sp-mobile-unit",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex justify-content-between gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("strong", {
                                                                                children: getUnitLabel(detail)
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-muted text-end",
                                                                                children: detail.pd_pdetail_barcode || "-"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "sp-mobile-unit-values",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: "ราคาแนะนำ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("strong", {
                                                                                    children: money(detail.pd_pdetail_recommentprice)
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "sp-mobile-price-row",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                children: "ราคาพิเศษ"
                                                                            }),
                                                                            detail.specialPrice === null || detail.specialPrice === undefined ? /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-muted",
                                                                                children: "ยังไม่ตั้งราคา"
                                                                            }) : /*#__PURE__*/ _jsx(SpecialPrice, {
                                                                                value: detail.specialPrice
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, detail.pd_pdetail_id);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        className: "w-100 mt-3",
                                                        variant: hasSpecialPrice(product) ? "outline-primary" : "primary",
                                                        onClick: function() {
                                                            return openPriceEditor(product, true);
                                                        },
                                                        children: hasSpecialPrice(product) ? "แก้ไขราคา" : "เพิ่มสินค้า"
                                                    })
                                                ]
                                            }, product.pd_product_id);
                                        }),
                                        !candidateLoading && !candidateProducts.length && /*#__PURE__*/ _jsx("div", {
                                            className: "text-center text-muted py-4",
                                            children: "ไม่พบสินค้าใช้งาน"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Pager, {
                                    pagination: candidatePagination,
                                    page: candidatePage,
                                    onPageChange: setCandidatePage,
                                    loading: candidateLoading
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Modal.Footer, {
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "outline-secondary",
                                onClick: closeModal,
                                children: "ปิด"
                            })
                        })
                    ]
                }) : modalMode === "editor" ? /*#__PURE__*/ _jsxs(Form, {
                    onSubmit: savePrice,
                    children: [
                        /*#__PURE__*/ _jsx(Modal.Header, {
                            closeButton: !saving,
                            children: /*#__PURE__*/ _jsx(Modal.Title, {
                                className: "h5",
                                children: hasSpecialPrice(selectedProduct) ? "แก้ไขราคาพิเศษสินค้า" : "เพิ่มสินค้าราคาพิเศษ"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Modal.Body, {
                            children: [
                                notice && /*#__PURE__*/ _jsx("div", {
                                    className: "alert alert-".concat(notice.type, " py-2"),
                                    children: notice.text
                                }),
                                selectedProduct && /*#__PURE__*/ _jsx("div", {
                                    className: "sp-editor-product mb-3",
                                    children: /*#__PURE__*/ _jsx(ProductIdentity, {
                                        product: selectedProduct
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "sp-editor-unit-list",
                                    children: getProductDetails(selectedProduct).map(function(detail) {
                                        var _priceInputs_detail_pd_pdetail_id;
                                        var priceValue = (_priceInputs_detail_pd_pdetail_id = priceInputs[detail.pd_pdetail_id]) !== null && _priceInputs_detail_pd_pdetail_id !== void 0 ? _priceInputs_detail_pd_pdetail_id : "";
                                        var parsedPrice = Number(priceValue);
                                        var validPrice = priceValue !== "" && Number.isFinite(parsedPrice) && parsedPrice >= 0;
                                        return /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "sp-editor-unit",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                    className: "mb-2",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "d-block fw-semibold",
                                                            children: getUnitLabel(detail)
                                                        }),
                                                        /*#__PURE__*/ _jsxs("span", {
                                                            className: "small text-muted",
                                                            children: [
                                                                "บาร์โค้ด ",
                                                                detail.pd_pdetail_barcode || "-",
                                                                " \xb7 ราคาแนะนำ ",
                                                                money(detail.pd_pdetail_recommentprice)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Row, {
                                                    className: "g-2 align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Col, {
                                                            xs: 12,
                                                            sm: 7,
                                                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "number",
                                                                min: "0",
                                                                step: "0.01",
                                                                inputMode: "decimal",
                                                                value: priceValue,
                                                                onChange: function(event) {
                                                                    return setPriceInputs(function(current) {
                                                                        return _object_spread_props(_object_spread({}, current), _define_property({}, detail.pd_pdetail_id, event.target.value));
                                                                    });
                                                                },
                                                                placeholder: "ราคาพิเศษ (Ex VAT)",
                                                                "aria-label": "ราคาพิเศษ ".concat(getUnitLabel(detail))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(Col, {
                                                            xs: 12,
                                                            sm: 5,
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "sp-editor-in-vat",
                                                                children: [
                                                                    "In VAT: ",
                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                        children: validPrice ? money(parsedPrice * VAT_MULTIPLIER) : "-"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, detail.pd_pdetail_id);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "small text-muted mt-3",
                                    children: "ระบุราคาพิเศษให้ครบทุกหน่วย ระบบจะนำโปรโมชั่นมาคำนวณต่อจากราคาพิเศษนี้"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Modal.Footer, {
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "outline-secondary",
                                    disabled: saving,
                                    onClick: cancelPriceEditor,
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-dg",
                                    disabled: saving,
                                    children: saving ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Spinner, {
                                                size: "sm",
                                                className: "me-2"
                                            }),
                                            "กำลังบันทึก..."
                                        ]
                                    }) : "บันทึกราคา"
                                })
                            ]
                        })
                    ]
                }) : null
            })
        ]
    });
}
